import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Hace tres semanas que tenemos el menú semanal organizado y la diferencia en mi nivel de estrés es enorme. Las recetas son reales, no de revista de cocina gourmet.',
    name: 'Valentina',
    desc: 'Mamá de mellizos de 3 años',
    img: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'Siempre supe que quería darle algo mejor a mi hija, pero no sabía por dónde empezar. NutriPeques me dio el sistema, no solo las recetas.',
    name: 'Lucía',
    desc: 'Mamá de Sofía, 2 años',
    img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'Los nuggets de pescado son un hit. Mi hijo come pescado. Nunca pensé que diría eso.',
    name: 'Romina',
    desc: 'Mamá de Tomás, 4 años',
    img: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: "Leí la parte del 'Sistema NutriPeques' y en serio sentí que alguien finalmente entendía mi vida real.",
    name: 'María',
    desc: 'Mamá de 2 niños, 3 y 6 años',
    img: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=200&h=200&fit=crop&crop=face'
  }];
  return <section className="py-16 px-4 bg-[#FFF8F0]" data-id="element-413">
      <div className="max-w-lg md:max-w-5xl mx-auto" data-id="element-414">
        <div className="text-center mb-12" data-id="element-415">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-416">
            ESTO DICE QUIEN LO CONOCE
          </h2>
          <div className="w-24 h-1 bg-[#FF8A65] mx-auto rounded-full" data-id="element-417"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-418">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-white p-6 md:p-8 rounded-3xl shadow-sm border border-[#FFE0B2] flex flex-col h-full" data-id="element-419">
              <div className="flex gap-1 mb-4" data-id="element-420">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#FFB300] text-[#FFB300]" data-id="element-421" />)}
              </div>
              <p className="text-gray-700 text-lg italic mb-6 flex-grow" data-id="element-422">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-423">
                <img src={t.img} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#FFE0B2]" data-id="element-424" />
                <div data-id="element-425">
                  <div className="font-bold text-gray-900" data-id="element-426">{t.name}</div>
                  <div className="text-sm text-gray-500" data-id="element-427">{t.desc}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}